module.exports = __webpack_public_path__ + "a8a10a3e/img/boston-lights.a623432f.png";